'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentStatus = void 0;
var DocumentStatus;
(function (DocumentStatus) {
    /**
     * A SOW verification has not been requested, but the user can still
     * perform it voluntarily
     */
    DocumentStatus["NOT_REQUESTED"] = "NOT_REQUESTED";
    /**
     * A SOW verification has been requested, and the user has not filled it
     * yet
     */
    DocumentStatus["REQUESTED"] = "PENDING";
    /**
     * A SOW verification has been requested and the user has filled it, but
     * it has not been approved yet
     */
    DocumentStatus["PROCESSING"] = "PROCESSING";
    /**
     * A SOW verification has been requested, filled and approved
     */
    DocumentStatus["APPROVED"] = "APPROVED";
})(DocumentStatus = exports.DocumentStatus || (exports.DocumentStatus = {}));
